import { render, staticRenderFns } from "./AddLoginModal.vue?vue&type=template&id=65bd305a&"
import script from "./AddLoginModal.vue?vue&type=script&lang=js&"
export * from "./AddLoginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports